import { useEffect, useState } from 'react';
import { staffAPI } from '../services/api';

/**
 * Excluded working-day dates for a leave window (PH, rest, rostered day off).
 *
 * Prefers ``excluded_dates`` already on the application (detail serializer).
 * Falls back to ``calculateLeaveDays`` for list-row payloads that omit it.
 */
export default function useLeaveExcludedDates(application, enabled = true) {
  const start = application?.leave_start_date;
  const end = application?.leave_end_date;
  const leaveTypeName = (
    application?.leave_type?.leave_type_name
    || application?.leave_type_name
    || ''
  );
  const provided = application?.excluded_dates;
  const providedKey = Array.isArray(provided)
    ? provided.map((day) => `${day.date}:${day.reason_code}`).join('|')
    : null;

  const [excludedDates, setExcludedDates] = useState(
    Array.isArray(provided) ? provided : [],
  );

  useEffect(() => {
    if (!enabled || !start || !end) {
      setExcludedDates([]);
      return;
    }
    if (Array.isArray(provided)) {
      setExcludedDates(provided);
      return;
    }

    let cancelled = false;
    staffAPI.calculateLeaveDays({
      start_date: start,
      end_date: end,
      leave_type_name: leaveTypeName,
    }).then((res) => {
      if (!cancelled) {
        setExcludedDates(res?.data?.calculation?.excluded_dates || []);
      }
    }).catch(() => {
      if (!cancelled) setExcludedDates([]);
    });

    return () => {
      cancelled = true;
    };
  }, [enabled, start, end, leaveTypeName, provided, providedKey]);

  return excludedDates;
}
